interface EventData {
  typeCalculated: string;
  serie: string;
  tiempo: string;
  descanso: string;
}

function calculatedEstimatedTime(rows: EventData[]): number {
  let totalTiempo = 0.0;

  for (const row of rows) {
    const { typeCalculated, serie, tiempo, descanso } = row;

    const serieNumber = Number(serie) || 0;
    const descansoNumber = Number(descanso) || 0;
    let tiempoNumber = Number(tiempo) || 0;

    const tiempoStr = tiempo?.toString?.() ?? "0"
    if (tiempoStr.includes(",") || tiempoStr.includes("+")) {
      const separator = tiempoStr.includes(",") ? "," : "+";
      tiempoNumber = Number(tiempoStr.split(separator)[0]) || 0;
    }

    console.log({
      typeCalculated,
      serie: serieNumber,
      tiempo: tiempoNumber,
      descanso: descansoNumber,
    });

    if (typeCalculated === "Seg") {
      totalTiempo += ((tiempoNumber + descansoNumber) * serieNumber) / 60;
    } else if (typeCalculated === "Rep") {
      totalTiempo += ((tiempoNumber * 5 + descansoNumber) * serieNumber) / 60;
    }
  }

  if (totalTiempo >= 1) {
    return Math.ceil(totalTiempo);
  } else if (totalTiempo > 0) {
    return 1;
  }
  return 0;
}

export { calculatedEstimatedTime };
